import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Product } from "@/types/product-type";

interface MockStore {
  id: string;
  name: string;
}

interface ProductDetailsTabProps {
  product: Product;
  store: MockStore;
}

export function ProductDetailsTab({ product, store }: ProductDetailsTabProps) {
  const getStatusColor = (isActive: boolean | null | undefined) => {
    return isActive ? "default" : "secondary";
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Product Information</CardTitle>
        <CardDescription>Basic product details and settings</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid gap-6 md:grid-cols-2">
          <div className="space-y-2">
            <h4 className="font-medium">Product Name</h4>
            <p className="text-sm text-muted-foreground">{product.name}</p>
          </div>
          <div className="space-y-2">
            <h4 className="font-medium">Product Code</h4>
            <p className="text-sm text-muted-foreground">{product.code}</p>
          </div>
          <div className="space-y-2">
            <h4 className="font-medium">Sale Code</h4>
            <p className="text-sm text-muted-foreground">
              {product.saleCode || "N/A"}
            </p>
          </div>
          <div className="space-y-2">
            <h4 className="font-medium">Status</h4>
            <Badge variant={getStatusColor(product.isActive)}>
              {product.isActive ? "Active" : "Inactive"}
            </Badge>
          </div>
          <div className="space-y-2">
            <h4 className="font-medium">Price</h4>
            <p className="text-sm text-muted-foreground">
              ${product.price.toFixed(2)}
            </p>
          </div>
          <div className="space-y-2">
            <h4 className="font-medium">Cost</h4>
            <p className="text-sm text-muted-foreground">
              {product.cost ? `$${product.cost.toFixed(2)}` : "N/A"}
            </p>
          </div>
          <div className="space-y-2">
            <h4 className="font-medium">Unit</h4>
            <p className="text-sm text-muted-foreground">
              {product.unit || "N/A"}
            </p>
          </div>
          <div className="space-y-2">
            <h4 className="font-medium">Quantity</h4>
            <p className="text-sm text-muted-foreground">
              {product.quantity || 0}
            </p>
          </div>
          <div className="space-y-2">
            <h4 className="font-medium">Store</h4>
            <p className="text-sm text-muted-foreground">{store.name}</p>
          </div>
        </div>
        {product.description && (
          <div className="space-y-2">
            <h4 className="font-medium">Description</h4>
            <p className="text-sm text-muted-foreground">
              {product.description}
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
